import { Box, useMediaQuery } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import { useTranslation } from "react-i18next"
import { STATICS } from "api/api"
import {ReactComponent as EstateToolLogo} from '/src/assets/svg/estatetool-logo.svg'
import { useBreak } from "hooks/useBreak"
import { useEffect, useState } from "react"
import LanguageMenu from "components/LanguageMenu/LanguageMenu"
import { MainFooter } from "components/MainFooter/MainFooter"

export const DevelopmentPage = () => {
    const { i18n, i18n: { language } } = useTranslation()
    const [viewportHeight, setViewportHeight] = useState(0);
    const isTabletOrAbove =   useMediaQuery('(min-width:600px)');

    useEffect(() => {
        // Function to update the viewport height
        const updateViewportHeight = () => {
        setViewportHeight(window.innerHeight);
        };
    
        // Set the viewport height on load
        updateViewportHeight();
    
        // Add resize event listener
        window.addEventListener("resize", updateViewportHeight);
    
        // Cleanup the event listener on unmount
        return () => {
        window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    return <Box sx = {{ position: 'relative', height: "100%" }}>
            <Box sx={{ 
                position: 'relative',
                width: '100%',
                height: viewportHeight
                }}>
                        <Box            sx      = {{ 
                            // pt: { xs:2, lg: 5 }, 
                            pt: 10,
                            px: { xs:2, lg: 5 }, 
                            height: "100%",
                            display: "flex",
                            flexDirection: "column"
                            }}>
    {/* <Box            sx      = {{ display: 'flex', alignContent: 'center', justifyContent: "space-between" }}>
    <Box            sx      = {{ height: { xs: 50, lg: 109 }, width: { xs: 100, lg: 229 },
                          '@media (min-width: 600px) and (max-height: 1000px)': {
                                               height: "100%",
                                               width : "130px"
                                    } }}>
    <EstateToolLogo style   = {{ width: '100%', height: '100%' }} />
                </Box>
             <Box sx = {{ position: 'relative', height: '100%'}}>
                 <LanguageMenu />
                </Box>
            </Box> */}
            <Box sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', height: "100%", justifyContent: "space-between", pt: { xs:2, lg: 0 } }}>
            <Box sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', gap: '40px' }}>
            <Box sx = {{ display: 'flex', justifyContent: 'center' }}>
                        <Box
                            component = "img"
                            alt       = "The house from the offer."
                            src       = {`${STATICS}svg/development-image.svg`}
                              sx={{
                                    width: '998px',
                                    '@media (min-width:1140px)': {
                                        width: '100%',
                                        maxWidth: '1000px'
                                    },
                                    '@media (max-width:1140px)': {
                                        width: 'calc(100% - 80px)',
                                    },
                                    '@media (max-width:800px)': {
                                        width: 'calc(100% - 40px)',
                                    },
                                    '@media (max-width:600px)': {
                                        width: 'calc(100% - 20px)',
                                    },
                                     '@media (max-width:500px)': {
                                        width: '100%',
                                    },
                                     '@media (min-width: 600px) and (max-height: 1000px)': {
                                        height   : 'calc(100vh - 400px)',
                                        minHeight: '30px'
                                    },
                                    fontSize: 0
                                }}
                        />
                    </Box>
                    <Box sx        = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '16px' }}>
                    <div  className = {isTabletOrAbove ? 'h1' : `h3`}>{ developmentPage.desc[language] }</div>
                    <Box className = "paragraph1-regular" sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '30px', maxWidth: "770px", alignSelf: 'center' }}>
                            <p>{ developmentPage.p1[language] }</p>
                            <p>{ developmentPage.p2[language] }</p>
                        </Box>
                    </Box>
                </Box>
                <PoweredBy />
            </Box>
                        </Box>
                </Box>
                  <MainFooter />
    </Box>
}



const developmentPage = {
    desc: {
        "en": "A new Estatetool property selector is on its way!",
        "da": "En ny Estatetool boligvælger er på vej!"
    },
    p1: {
        "en": "Soon we will launch another Estatetool home selector - your perfect tool to find your dream home. We are working behind the scenes to create an experience that makes the home search both easier and more user-friendly.",
        "da": "Snart lancerer vi endnu en Estatetool boligvælger - dit perfekte værktøj til at finde drømmeboligen. Vi arbejder bag kulisserne for at skabe en oplevelse, der gør boligjagten både nemmere og mere brugervenlig."
    },
    p2: {
        "en": "Thank you for your patience - it will definitely be worth the wait!",
        "da": "Tak for din tålmodighed - det bliver uden tvivl ventetiden værd!"
    }
}